import { formatDate } from "@/features/FormCard/utils";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import i18n from "@/i18n";
import { useQueryCache } from "@/hooks/useQueyCache";
import { Button } from "@heroui/button";
import { Card, CardBody, CardHeader } from "@heroui/card";
import { Divider } from "@heroui/divider";
import { Input } from "@heroui/input";
import { Link } from "@heroui/link";
import { Control, useController } from "react-hook-form";
import { useTranslation } from "react-i18next";

type TInfoCardProps = {
  id: number;
  table_name: string;
  client: string;
  strategy_id_control: Control<any>;
};

interface ItemData {
  id: number;
  created_at: string;
  updated_at: string;
  [key: string]: any;
}

export function TechnicalInfoCardStatic({
  id,
  table_name,
  client,
  strategy_id_control,
}: TInfoCardProps) {
  const { t } = useTranslation(["common", "tables"]);
  const data = useQueryCache<ItemData>([client, table_name, "get", "item", id]);

  const { field } = useController({
    name: "strategy_id",
    control: strategy_id_control,
  });

  return (
    <div className="grid place-items-center bg-gray-50 h-full max-w-card w-full">
      <div className="flex justify-center w-full">
        <Card className="p-4 bg-white w-full">
          <CardHeader className="text-sm">
            {t("technical_info.title", {
              defaultValue: "Informations techniques",
            })}
          </CardHeader>
          <Divider />
          <CardBody>
            <div className="grid grid-cols-2 lg:flex lg:flex-row py-2 gap-3">
              <Input
                radius="full"
                variant="bordered"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("a6_static_data.columns.strategy_id", {
                  ns: "tables",
                  defaultValue: "ID de la stratégie",
                })}
                {...field}
                endContent={
                  field.value ? (
                    <Button
                      href={toWorkspacePath(
                        `/admin/qtl%20-%20referential/strategies/${encodeURIComponent(String(field.value))}`,
                      )}
                      variant="light"
                      color="primary"
                      showAnchorIcon
                      as={Link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-transparent shadow-none p-0 min-w-0 h-6 w-6"
                    />
                  ) : null
                }
              />
              <Input
                radius="full"
                variant="underlined"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("technical_info.id", { defaultValue: "ID" })}
                value={id.toString()}
              />
              <Input
                radius="full"
                variant="underlined"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("technical_info.created_at", {
                  defaultValue: "Créé le",
                })}
                value={formatDate(data?.created_at || "", i18n.language)}
              />
              <Input
                radius="full"
                variant="underlined"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("technical_info.updated_at", {
                  defaultValue: "Mis à jour le",
                })}
                value={formatDate(data?.updated_at || "", i18n.language)}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
